export const isShareCancellation = (error: unknown) =>
  error instanceof Error &&
  (error.name === "AbortError" || /abort due to cancellation of share/i.test(error.message))
